export const DictionaryExpress = [
    {
        id: 'test',
        label: 'Search',
        targets: [
            {
                id: 'x-learn-search-panel',
                label: 'Search',
            },
        ],
    },
    {
        id: 'x-learn-your-stuff-panel',
        label: 'Your Stuff',
        targets: [
            {
                id: 'x-learn-your-stuff-panel',
                label: 'Your Stuff',
            },
        ],
    },
    {
        id: 'x-learn-assets-panel',
        label: 'Assets',
        targets: [
            {
                id: 'x-learn-assets-panel',
                label: 'Assets',
            },
        ],
    },
    {
        id: 'x-learn-your-stuff-files-tab',
        label: 'Files',
        targets: [
            {
                id: 'x-learn-your-stuff-files-tab',
                label: 'Files',
            },
            {
                id: 'x-learn-your-stuff-panel',
                label: 'Your Stuff > Files',
            },
        ],
    },
    {
        id: 'x-learn-your-stuff-brands-libraries',
        label: 'Libraries',
        targets: [
            {
                id: 'x-learn-your-stuff-brands-libraries',
                label: 'Libraries',
            },
            {
                id: 'x-learn-your-stuff-panel',
                label: 'Your Stuff > Libraries',
            },
        ],
    },
    {
        id: 'x-learn-your-stuff-add-brand-library',
        label: 'Add library',
        targets: [
            {
                id: 'x-learn-your-stuff-add-brand-library',
                label: 'Add a Library or Brand',
            },
            {
                id: 'x-learn-your-stuff-brands-libraries',
                label: 'Libraries > Add a Library',
            },
            {
                id: 'x-learn-your-stuff-panel',
                label: 'Your Stuff > Libraries > Add a Library',
            },
        ],
    },
    {
        id: 'x-learn-your-stuff-invite-brand-library',
        label: 'Invite to library icon',
        targets: [
            {
                id: 'x-learn-your-stuff-invite-brand-library',
                label: 'Invite to library',
            },
            {
                id: 'x-learn-your-stuff-brands-libraries',
                label: 'Libraries > Select library to invite users',
            },
            {
                id: 'x-learn-your-stuff-panel',
                label: 'Your Stuff > Libraries > Select library to invite users',
            },
        ],
    },
    {
        id: 'x-learn-your-stuff-brands-library',
        label: 'Library info',
        targets: [
            {
                id: 'x-learn-your-stuff-brands-library',
                label: 'More options',
            },
            {
                id: 'x-learn-your-stuff-brands-libraries',
                label: 'Libraries > Hover over a library to see more options',
            },
            {
                id: 'x-learn-your-stuff-panel',
                label: 'Your Stuff > Libraries > Hover over a library to see more options',
            },
        ],
    },
    {
        id: 'x-learn-templates-panel',
        label: 'Templates',
        targets: [
            {
                id: 'x-learn-templates-panel',
                label: 'Templates',
            },
        ],
    },
    {
        id: 'x-learn-templates-t2t',
        label: 'Text to Template',
        targets: [
            {
                id: 'x-learn-templates-t2t',
                label: 'Generate template',
            },
            {
                id: 'x-learn-templates-panel',
                label: 'Templates > Generate template',
            },
        ],
    },
    {
        id: 'x-learn-media-panel',
        label: 'Media',
        targets: [
            {
                id: 'x-learn-media-panel',
                label: 'Media',
            },
        ],
    },
    {
        id: 'x-learn-media-panel-photos',
        label: 'Photos',
        targets: [
            {
                id: 'x-learn-media-panel-photos',
                label: 'Photos',
            },
            {
                id: 'x-learn-media-panel',
                label: 'Media > Photos',
            },
        ],
    },
    {
        id: 'x-learn-media-upload',
        label: 'Upload from device',
        targets: [
            {
                id: 'x-learn-media-upload',
                label: 'Upload from device',
            },
            {
                id: 'x-learn-media-panel',
                label: 'Media > Photos > Upload from device',
            },
        ],
    },
    {
        id: 'x-learn-media-t2image',
        label: 'Text to Image',
        targets: [
            {
                id: 'x-learn-media-t2image',
                label: 'Generate image',
            },
            {
                id: 'x-learn-media-panel',
                label: 'Media > Photos > Generate image',
            },
        ],
    },
    {
        id: 'x-learn-replace',
        label: 'Replace icon',
        targets: [
            {
                id: 'x-learn-replace',
                label: 'Replace',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a layer > Replace',
            },
        ],
    },
    {
        id: 'x-learn-duplicate',
        label: 'Duplicate icon',
        targets: [
            {
                id: 'x-learn-duplicate',
                label: 'Duplicate',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a layer > Duplicate',
            },
        ],
    },
    {
        id: 'x-learn-lock-layer',
        label: 'Lock icon',
        targets: [
            {
                id: 'x-learn-lock-layer',
                label: 'Lock',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a layer > Lock',
            },
        ],
    },
    {
        id: 'x-learn-source-info',
        label: 'Source info icon',
        targets: [
            {
                id: 'x-learn-source-info',
                label: 'Source info',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a layer > Source info',
            },
        ],
    },
    {
        id: 'x-learn-gen-fill',
        label: 'Generative fill',
        targets: [
            {
                id: 'x-learn-gen-fill',
                label: 'Generative fill',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select an image layer > Generative fill',
            },
        ],
    },
    {
        id: 'x-learn-erase',
        label: 'Erase',
        targets: [
            {
                id: 'x-learn-erase',
                label: 'Erase',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select an image layer > Erase',
            },
        ],
    },
    {
        id: 'x-learn-remove-background',
        label: 'Remove background',
        targets: [
            {
                id: 'x-learn-remove-background',
                label: 'Remove background',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select an image layer > Remove background',
            },
        ],
    },
    {
        id: 'x-learn-crop',
        label: 'Crop',
        targets: [
            {
                id: 'x-learn-crop',
                label: 'Crop',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select an image layer > Crop',
            },
        ],
    },
    {
        id: 'x-learn-blend',
        label: 'Blend',
        targets: [
            {
                id: 'x-learn-blend',
                label: 'Blend',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select an image layer > Blend',
            },
        ],
    },
    {
        id: 'x-learn-flip-horizontal',
        label: 'Flip horizontal icon',
        targets: [
            {
                id: 'x-learn-flip-horizontal',
                label: 'Flip horizontally',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select an image layer > Flip horizontally',
            },
        ],
    },
    {
        id: 'x-learn-flip-vertical',
        label: 'Flip vertical icon',
        targets: [
            {
                id: 'x-learn-flip-vertical',
                label: 'Flip vertically',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select an image layer > Flip vertically',
            },
        ],
    },
    {
        id: 'x-learn-set-background',
        label: 'Set as page background icon',
        targets: [
            {
                id: 'x-learn-set-background',
                label: 'Set as page background',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select an image layer > Set as page background',
            },
        ],
    },
    {
        id: 'x-learn-effects',
        label: 'Effects',
        targets: [
            {
                id: 'x-learn-effects',
                label: 'Effects',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select an image layer > Effects',
            },
        ],
    },
    {
        id: 'x-learn-adjustments',
        label: 'Adjustments',
        targets: [
            {
                id: 'x-learn-adjustments',
                label: 'Adjustments',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select an image layer > Adjustments',
            },
        ],
    },
    {
        id: 'x-learn-animation',
        label: 'Animation',
        targets: [
            {
                id: 'x-learn-animation',
                label: 'Animation',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a layer > Animation',
            },
        ],
    },
    {
        id: 'x-learn-media-panel-video',
        label: 'Videos',
        targets: [
            {
                id: 'x-learn-media-panel-video',
                label: 'Videos',
            },
            {
                id: 'x-learn-media-panel',
                label: 'Media > Video',
            },
        ],
    },
    {
        id: 'x-learn-edit-timeline',
        label: 'Edit timeline',
        targets: [
            {
                id: 'x-learn-edit-timeline',
                label: 'Edit timeline',
            },
            {
                id: 'x-learn-add-page-scene',
                label: 'Add time to this page',
            },
        ],
    },
    {
        id: 'x-learn-sceneline-layer-timing',
        label: 'Show layer timing',
        targets: [
            {
                id: 'x-learn-sceneline-layer-timing',
                label: 'Show layer timing',
            },
            {
                id: 'x-learn-edit-timeline',
                label: 'Edit timeline > Show layer timing',
            },
        ],
    },
    {
        id: 'x-learn-sceneline-zoom',
        label: 'Timeline zoom',
        targets: [
            {
                id: 'x-learn-sceneline-zoom',
                label: 'Zoom',
            },
            {
                id: 'x-learn-edit-timeline',
                label: 'Edit timeline > Zoom',
            },
        ],
    },
    {
        id: 'x-learn-sceneline-add-scene',
        label: 'Add scene',
        targets: [
            {
                id: 'x-learn-sceneline-add-scene',
                label: 'Add a scene',
            },
            {
                id: 'x-learn-edit-timeline',
                label: 'Edit timeline > Add a scene',
            },
        ],
    },
    {
        id: 'x-learn-sceneline-play',
        label: 'Play icon',
        targets: [
            {
                id: 'x-learn-sceneline-play',
                label: 'Play',
            },
            {
                id: 'x-learn-edit-timeline',
                label: 'Edit timeline > Play',
            },
        ],
    },
    {
        id: 'x-learn-media-panel-audio',
        label: 'Audio',
        targets: [
            {
                id: 'x-learn-media-panel-audio',
                label: 'Audio',
            },
            {
                id: 'x-learn-media-panel',
                label: 'Media > Audio',
            },
        ],
    },
    {
        id: 'x-learn-media-record-voiceover',
        label: 'Record voiceover',
        targets: [
            {
                id: 'x-learn-media-record-voiceover',
                label: 'Record voiceover',
            },
            {
                id: 'x-learn-media-panel-audio',
                label: 'Audio > Record voiceover',
            },
            {
                id: 'x-learn-media-panel',
                label: 'Media > Audio > Record voiceover',
            },
        ],
    },
    {
        id: 'x-learn-text-panel',
        label: 'Text',
        targets: [
            {
                id: 'x-learn-text-panel',
                label: 'Text',
            },
        ],
    },
    {
        id: 'x-learn-text-add',
        label: 'Add your text',
        targets: [
            {
                id: 'x-learn-text-add',
                label: 'Add your text',
            },
            {
                id: 'x-learn-text-panel',
                label: 'Text > Add text',
            },
        ],
    },
    {
        id: 'x-learn-text-bold',
        label: 'Bold icon',
        targets: [
            {
                id: 'x-learn-text-bold',
                label: 'Bold',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Bold',
            },
        ],
    },
    {
        id: 'x-learn-text-italic',
        label: 'Italic icon',
        targets: [
            {
                id: 'x-learn-text-italic',
                label: 'Italic',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Italic',
            },
        ],
    },
    {
        id: 'x-learn-text-underline',
        label: 'Underline icon',
        targets: [
            {
                id: 'x-learn-text-underline',
                label: 'Underline',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Underline',
            },
        ],
    },
    {
        id: 'x-learn-text-alignment',
        label: 'Alignment icon',
        targets: [
            {
                id: 'x-learn-text-alignment',
                label: 'Alignment',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Alignment',
            },
        ],
    },
    {
        id: 'x-learn-text-bullets',
        label: 'Bullets icon',
        targets: [
            {
                id: 'x-learn-text-bullets',
                label: 'Bullets',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Bullets',
            },
        ],
    },
    {
        id: 'x-learn-text-line-spacing',
        label: 'Spacing icon',
        targets: [
            {
                id: 'x-learn-text-line-spacing',
                label: 'Spacing',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Spacing',
            },
        ],
    },
    {
        id: 'x-learn-text-layout-default',
        label: 'Default',
        targets: [
            {
                id: 'x-learn-text-layout-default',
                label: 'Default text',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Default text',
            },
        ],
    },
    {
        id: 'x-learn-text-layout-dynamic',
        label: 'Dynamic',
        targets: [
            {
                id: 'x-learn-text-layout-dynamic',
                label: 'Dynamic text',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Dynamic text',
            },
        ],
    },
    {
        id: 'x-learn-text-layout-circle',
        label: 'Circle',
        targets: [
            {
                id: 'x-learn-text-layout-circle',
                label: 'Circle text',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Circle text',
            },
        ],
    },
    {
        id: 'x-learn-text-layout-arch',
        label: 'Arch',
        targets: [
            {
                id: 'x-learn-text-layout-arch',
                label: 'Arch text',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Arch text',
            },
        ],
    },
    {
        id: 'x-learn-text-layout-bow',
        label: 'Bow',
        targets: [
            {
                id: 'x-learn-text-layout-bow',
                label: 'Bow text',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Bow text',
            },
        ],
    },
    {
        id: 'x-learn-text-color',
        label: 'Fill',
        targets: [
            {
                id: 'x-learn-text-color',
                label: 'Text fill',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Fill text',
            },
        ],
    },
    {
        id: 'x-learn-text-outline-color',
        label: 'Outline',
        targets: [
            {
                id: 'x-learn-text-outline-color',
                label: 'Text outline',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Text outline',
            },
        ],
    },
    {
        id: 'x-learn-text-effects',
        label: 'Text effects',
        targets: [
            {
                id: 'x-learn-text-effects',
                label: 'Text effects',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Text effects',
            },
        ],
    },
    {
        id: 'x-learn-text-shadow',
        label: 'Shadow',
        targets: [
            {
                id: 'x-learn-text-shadow',
                label: 'Text shadow',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Text shadow',
            },
        ],
    },
    {
        id: 'x-learn-text-shape',
        label: 'Shape',
        targets: [
            {
                id: 'x-learn-text-shape',
                label: 'Text shape',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Text shape',
            },
        ],
    },
    {
        id: 'x-learn-text-reflow',
        label: 'Text reflowing box',
        targets: [
            {
                id: 'x-learn-text-reflow',
                label: 'Text flow',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a text layer > Text flow',
            },
        ],
    },
    {
        id: 'x-learn-lock-layer',
        label: 'Unlock icon',
        targets: [
            {
                id: 'x-learn-lock-layer',
                label: 'Unlock',
            },
        ],
    },
    {
        id: 'x-learn-group',
        label: 'Group',
        targets: [],
    },
    {
        id: 'x-learn-ungroup',
        label: 'Ungroup',
        targets: [
            {
                id: 'x-learn-ungroup',
                label: 'Ungroup',
            },
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Select a grouped layer > Ungroup',
            },
        ],
    },
    {
        id: 'x-learn-elements-panel',
        label: 'Elements',
        targets: [
            {
                id: 'x-learn-elements-panel',
                label: 'Elements',
            },
        ],
    },
    {
        id: 'x-learn-elements-design-assets',
        label: 'Design assets',
        targets: [
            {
                id: 'x-learn-elements-design-assets',
                label: 'Design assets',
            },
            {
                id: 'x-learn-elements-panel',
                label: 'Elements > Design assets',
            },
        ],
    },
    {
        id: 'x-learn-elements-backgrounds',
        label: 'Backgrounds',
        targets: [
            {
                id: 'x-learn-elements-backgrounds',
                label: 'Backgrounds',
            },
            {
                id: 'x-learn-elements-panel',
                label: 'Elements > Backgrounds',
            },
        ],
    },
    {
        id: 'x-learn-elements-shapes',
        label: 'Shapes',
        targets: [
            {
                id: 'x-learn-elements-shapes',
                label: 'Shapes',
            },
            {
                id: 'x-learn-elements-panel',
                label: 'Elements > Shapes',
            },
        ],
    },
    {
        id: 'x-learn-elements-icons',
        label: 'Icons',
        targets: [
            {
                id: 'x-learn-elements-icons',
                label: 'Icons',
            },
            {
                id: 'x-learn-elements-panel',
                label: 'Elements > Icons',
            },
        ],
    },
    {
        id: 'x-learn-grids-panel',
        label: 'Grids',
        targets: [
            {
                id: 'x-learn-grids-panel',
                label: 'Grids',
            },
        ],
    },
    {
        id: 'x-learn-brands-panel',
        label: 'Brands',
        targets: [
            {
                id: 'x-learn-brands-panel',
                label: 'Brands',
            },
        ],
    },
    {
        id: 'x-learn-add-ons-panel',
        label: 'Add Ons',
        targets: [
            {
                id: 'x-learn-add-ons-panel',
                label: 'Add Ons',
            },
        ],
    },
    {
        id: 'x-learn-add-ons-discover',
        label: 'Discover',
        targets: [
            {
                id: 'x-learn-add-ons-discover',
                label: 'Discover Add Ons',
            },
            {
                id: 'x-learn-add-ons-panel',
                label: 'Add Ons > Discover Add Ons',
            },
        ],
    },
    {
        id: 'x-learn-add-ons-yours',
        label: 'Your Add Ons',
        targets: [
            {
                id: 'x-learn-add-ons-yours',
                label: 'Your Add Ons',
            },
            {
                id: 'x-learn-add-ons-panel',
                label: 'Add Ons > Your Add Ons',
            },
        ],
    },
    {
        id: 'x-learn-resize',
        label: 'Resize',
        targets: [
            {
                id: 'x-learn-resize',
                label: 'Resize',
            },
        ],
    },
    {
        id: 'x-learn-color-theme',
        label: 'Theme',
        targets: [
            {
                id: 'x-learn-color-theme',
                label: 'Theme',
            },
        ],
    },
    {
        id: 'x-learn-background-color',
        label: 'Background color',
        targets: [
            {
                id: 'x-learn-background-color',
                label: 'Background color',
            },
        ],
    },
    {
        id: 'x-learn-align',
        label: 'Align',
        targets: [
            {
                id: 'x-learn-align',
                label: 'Align',
            },
        ],
    },
    {
        id: 'x-learn-translate',
        label: 'Translate',
        targets: [
            {
                id: 'x-learn-translate',
                label: 'Translate',
            },
        ],
    },
    {
        id: 'x-learn-resize-lock-aspect-ratio',
        label: 'Lock icon',
        targets: [
            {
                id: 'x-learn-resize-lock-aspect-ratio',
                label: 'Lock aspect ratio',
            },
            {
                id: 'x-learn-resize',
                label: 'Resize > Lock aspect ratio',
            },
        ],
    },
    {
        id: 'x-learn-color-picker',
        label: 'Dropper icon',
        targets: [
            {
                id: 'x-learn-color-picker',
                label: 'Dropper',
            },
            {
                id: 'x-learn-background-color',
                label: 'Background color > Dropper',
            },
        ],
    },
    {
        id: 'x-learn-color-swatches',
        label: 'Swatches',
        targets: [
            {
                id: 'x-learn-color-swatches',
                label: 'Color swatch',
            },
            {
                id: 'x-learn-background-color',
                label: 'Background color > Color swatch',
            },
        ],
    },
    {
        id: 'x-learn-color-custom',
        label: 'Custom',
        targets: [
            {
                id: 'x-learn-color-custom',
                label: 'Custom color',
            },
            {
                id: 'x-learn-background-color',
                label: 'Background color > Custom color',
            },
        ],
    },
    {
        id: 'x-learn-color-more-colors',
        label: 'More colors',
        targets: [
            {
                id: 'x-learn-color-more-colors',
                label: 'More colors',
            },
            {
                id: 'x-learn-background-color',
                label: 'Background color > More colors',
            },
        ],
    },
    {
        id: 'x-learn-color-copy-to-clipboard',
        label: 'Copy to clipboard icon',
        targets: [
            {
                id: 'x-learn-color-copy-to-clipboard',
                label: 'Copy to clipboard',
            },
            {
                id: 'x-learn-color-custom',
                label: 'Custom > Copy to clipboard',
            },
            {
                id: 'x-learn-background-color',
                label: 'Background color > Custom > Copy to clipboard',
            },
        ],
    },
    {
        id: 'x-learn-zoom-picker',
        label: 'Zoom picker',
        targets: [
            {
                id: 'x-learn-zoom-picker',
                label: 'Zoom',
            },
        ],
    },
    {
        id: 'x-learn-page-grid',
        label: 'View all pages icon',
        targets: [
            {
                id: 'x-learn-page-grid',
                label: 'View all pages',
            },
        ],
    },
    {
        id: 'x-learn-toggle-layer-stack',
        label: 'Layers stack toggle',
        targets: [
            {
                id: 'x-learn-toggle-layer-stack',
                label: 'Layer stack',
            },
        ],
    },
    {
        id: 'x-learn-delete-page',
        label: 'Delete page icon',
        targets: [
            {
                id: 'x-learn-delete-page',
                label: 'Delete page',
            },
        ],
    },
    {
        id: 'x-learn-add-page-scene',
        label: 'Add icon',
        targets: [
            {
                id: 'x-learn-add-page-scene',
                label: 'Add page',
            },
        ],
    },
    {
        id: 'x-learn-next-page',
        label: 'Next page icon',
        targets: [
            {
                id: 'x-learn-next-page',
                label: 'Next page',
            },
        ],
    },
];
